import React from 'react'
import Helmet from 'react-helmet'
import { injectIntl } from 'sb-react-intl'
import { sentry, string } from 'common/helpers'

import messages from './messages'


type GlobalHelmetProps = {
  intl: ReactIntl
  gender: Gender
  pathname: string
  subscriptionPrice: string
}

const GlobalHelmet: React.FunctionComponent<GlobalHelmetProps> = ({ intl, gender, pathname, subscriptionPrice }) => {
  const isCorrectGender = [ 'male', 'female' ].includes(gender)

  if (!isCorrectGender) {
    sentry.captureException('Not correct gender in GlobalHelmet', {
      extra: { gender, pathname },
    })
  }

  const genderMessages = isCorrectGender ? messages[gender] : messages.female
  const title = intl.formatMessage(genderMessages.title, { subscriptionPrice })
  const description = string.multiLineToOneLine(
    intl.formatMessage(genderMessages.description, { subscriptionPrice }),
  )

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://cdn.scentbird.com/facebook.png" />
      <link rel="canonical" href={`https://www.scentbird.com${pathname}`} />
    </Helmet>
  )
}


export default injectIntl(GlobalHelmet)
